import { render, staticRenderFns } from "./CharacterCertificate.vue?vue&type=template&id=39f6bf85"
import script from "./CharacterCertificate.vue?vue&type=script&lang=js"
export * from "./CharacterCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports